import { Component, Vue } from 'vue-property-decorator';
import WithRender from './app.html';

@WithRender
@Component
export default class App extends Vue {
}
